import { fromJS } from 'immutable';
import { isString } from '../../../../../form/formUtilities';

export const depositSearchModel = fromJS({
  name: 'depositSearchForm',
  initialValues: {
    id: '',
    minId: '',
    maxId: '',
    minYear: '',
    maxYear: '',
    publicationType: '',
    minGeologicAgeId: '',
    maxGeologicAgeId: '',
    bodyOfWater: '',
    country: '',
    minLatitude: '',
    maxLatitude: '',
    minLongitude: '',
    maxLongitude: '',

    radios: {

      // authorStart: '',
      // authorInclude: '',
      // authorMatch: '',
      // authorNot: '',
      //    eventStart: '',
      //     eventInclude: '',
      //     eventMatch: '',
      //     eventNot: '',
      //    locStart: '',
      //     locInclude: '',
      //     locMatch: '',
      //     locNot: '',

      locationSearchType: 'locInclude',
      loc: '',
      authorSearchType: 'authorInclude',
      author: '',
      eventSearchType: 'eventInclude',
      event: '',
    },
  },
});


export const toSearchParameters = (model) => {
  const search = model.toJS();
  const {
    radios: {
      locationSearchType,
      loc,
      authorSearchType,
      author,
      eventSearchType,
      event,
    },
  } = search;

  if (locationSearchType) {
    search[locationSearchType] = loc;
  }

  if (authorSearchType) {
    search[authorSearchType] = author;
  }

  if (eventSearchType) {
    search[eventSearchType] = event;
  }

  delete search.radios;


  Object.keys(search).forEach((key) => {
    let value = search[key];
    if (isString(value)) {
      value = value.trim();
      if (value) {
        search[key] = value;
      } else {
        delete search[key];
      }
    }
  });

  return search;
};
